import { render, staticRenderFns } from "./inboundStudentChart.vue?vue&type=template&id=4a5c51ca"
import script from "./inboundStudentChart.vue?vue&type=script&lang=js"
export * from "./inboundStudentChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports